import { useMemo } from 'react';
import { createSearchParams } from 'react-router-dom';
import { ROUTES } from '../../Base.constants';
import { ItemType, NavigationItem } from '../../models/Navigation';
import useFetchFilterOptions from '../tags/useFetchFilterOptions';

const FILTER_TYPE_SECTOR = 'sector';

interface UseFetchSectorOptionsResult {
  data: NavigationItem[];
}

export default (): UseFetchSectorOptionsResult => {
  const { data: sectorOptions } = useFetchFilterOptions(FILTER_TYPE_SECTOR);
  const data = useMemo(() => {
    const result: NavigationItem[] = (sectorOptions || []).map((option) => {
      return {
        type: ItemType.NAVLINK,
        text: option.displayName,
        to: `${ROUTES.globalFeed}?${createSearchParams({
          sector: [option.tagId, ...(option.children?.map((child) => child.tagId) || [])],
        })}`,
      };
    });
    return result;
  }, [sectorOptions]);
  return { data };
};
